import Cookies from 'js-cookie'

const baseDomain = window.location.hostname === 'localhost'
  ? process.env.REACT_APP_LOCAL_API
  : window.location.origin

const umfragenDomain = window.location.hostname === 'localhost'
  ? process.env.REACT_APP_LOCAL_UMFRAGEN_URL
  : process.env.REACT_APP_PUBLIC_UMFRAGEN_URL

export { baseDomain, umfragenDomain }

export function getAuthHeaders() {
  const token = Cookies.get('auth_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function authFetch(url, options = {}) {
  const headers = {
    ...getAuthHeaders(),
    ...options.headers
  }

  const res = await fetch(url, { ...options, headers })

  // On 401, redirect to login
  if (res.status === 401 && !(process.env.NODE_ENV === 'development' && window.location.pathname === '/preview/abstimmung-signup')) {
    Cookies.remove('auth_token')
    Cookies.remove('user')
    Cookies.remove('authenticated')
    window.location.href = '/'
    return res
  }

  return res
}

// Convenience methods
export function apiGet(path) {
  return authFetch(`${baseDomain}${path}`, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' }
  })
}

export function apiPost(path, body) {
  return authFetch(`${baseDomain}${path}`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
}

export function apiPut(path, body) {
  return authFetch(`${baseDomain}${path}`, {
    method: 'PUT',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
}

export function apiUpload(path, formData) {
  // multipart/form-data upload — NO Content-Type header, the browser sets the
  // boundary itself. Auth header only.
  return authFetch(`${baseDomain}${path}`, {
    method: 'POST',
    headers: { ...getAuthHeaders() },
    body: formData
  })
}

export function apiPatch(path, body) {
  return authFetch(`${baseDomain}${path}`, {
    method: 'PATCH',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
}

export function apiDelete(path, body) {
  // DELETE with an optional JSON body. Most fetch implementations and Express
  // body-parsers allow this. Callers that need to send id/url via query string
  // can still do so by encoding them in `path` — the server reads both.
  return authFetch(`${baseDomain}${path}`, {
    method: 'DELETE',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  })
}
